module.exports = "query RecaptchaKeyQuery{recaptchaKey}"